import React, { useEffect, useState } from 'react';
import { TOAST_EVENT_NAME } from '../utils/toast';
import './ToastHost.css';

function ToastHost() {
  const [toasts, setToasts] = useState([]);

  useEffect(() => {
    const handleToast = (event) => {
      const toast = event.detail;
      if (!toast?.id || !toast.message) return;

      setToasts((current) => [...current, toast]);
      window.setTimeout(() => {
        setToasts((current) => current.filter((item) => item.id !== toast.id));
      }, toast.duration || 4000);
    };

    window.addEventListener(TOAST_EVENT_NAME, handleToast);
    return () => window.removeEventListener(TOAST_EVENT_NAME, handleToast);
  }, []);

  if (toasts.length === 0) return null;

  return (
    <div className="toast-host" aria-live="polite" aria-relevant="additions">
      {toasts.map((toast) => (
        <div key={toast.id} className={`toast toast--${toast.type || 'info'}`}>
          <span>{toast.message}</span>
          <button
            type="button"
            className="toast__close"
            onClick={() => setToasts((current) => current.filter((item) => item.id !== toast.id))}
            aria-label="通知を閉じる"
          >
            x
          </button>
        </div>
      ))}
    </div>
  );
}

export default ToastHost;
